const _ = require('underscore');
const alasql = require('alasql');

var tools = require("./Tools");

alasql.fn.letters = function(str, search) {
    for (var i = 0; i < search.length; i++)
    {
        if (str.includes(search[i]))
            return true;
    }
    return false;
};

module.exports = {

    sql(line, params)
    {
        if (!params.sql)
            return true;
            
        var res = alasql('SELECT * FROM ? WHERE ' + params.sql, [[line]]);
        if (res.length > 0)
            return true;
        return false;
    },

    inferior(line, params, casse)
    {
        if (!line.hasOwnProperty(params["column"]))
            var nb = 0;
        else if (_.isArray(line[params["column"]]))
            var nb = line[params["column"]].length;
        else
            var nb = parseFloat(line[params["column"]]);
        if (nb == NaN)
            return false;
        if (nb < params["value"])
            return true;
        return false;
    },

    inferior_equal(line, params, casse)
    {
        if (!line.hasOwnProperty(params["column"]))
            var nb = 0;
        else if (_.isArray(line[params["column"]]))
            var nb = line[params["column"]].length;
        else
            var nb = parseFloat(line[params["column"]]);
        if (nb == NaN)
            return false;
        if (nb <= params["value"])
            return true;
        return false;
    },

    superior(line, params, casse)
    {
        if (!line.hasOwnProperty(params["column"]))
            var nb = 0;
        else if (_.isArray(line[params["column"]]))
            var nb = line[params["column"]].length;
        else
            var nb = parseFloat(line[params["column"]]);

        if (nb == NaN)
            return false;
        if (nb > params["value"])
            return true;
        return false;
    },

    superior_equal(line, params, casse)
    {
        if (!line.hasOwnProperty(params["column"]))
            var nb = 0;
        else if (_.isArray(line[params["column"]]))
            var nb = line[params["column"]].length;
        else
            var nb = parseFloat(line[params["column"]]);
        if (nb == NaN)
            return false;
        if (nb >= params["value"])
            return true;
        return false;
    },

    equal(line, params, casse)
    {
        var value = line[params["column"]];

        if (!line.hasOwnProperty(params["column"]))
            value = "";
        if (_.isArray(line[params["column"]]))
            value = line[params["column"]].length.toString();
        if (_.isNumber(value))
            value = value.toString();

        if (tools.search(value, params["value"], casse).length > 0)
            return true;
        return false;
    },

    different(line, params, casse)
    {
        var value = line[params["column"]];

        if (!line.hasOwnProperty(params["column"]))
            value = "";
        if (_.isArray(line[params["column"]]))
            value = line[params["column"]].length.toString();
        if (_.isNumber(value))
            value = value.toString();
        
        if (tools.search(value, params["value"], casse).length == 0)
            return true;
        return false;
    },

}